/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ChangeSetTitle = {
    AdministrativeInformation: 'AdministrativeInformation',
    UseInEvaluation: 'UseInEvaluation',
    UseInSetup: 'UseInSetup'
} as const;
export type ChangeSetTitle = typeof ChangeSetTitle[keyof typeof ChangeSetTitle];


export function ChangeSetTitleFromJSON(json: any): ChangeSetTitle {
    return ChangeSetTitleFromJSONTyped(json, false);
}

export function ChangeSetTitleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeSetTitle {
    return json as ChangeSetTitle;
}

export function ChangeSetTitleToJSON(value?: ChangeSetTitle | null): any {
    return value as any;
}

/**
 * Check if a given object implements the ChangeSetTitle interface.
 */
 export function instanceOfChangeSetTitle(value: any): value is ChangeSetTitle {
    return Object.values(ChangeSetTitle).includes(value)
}

